import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { BeforeAfter } from '../BeforeAfter';
import { img } from '../../data/site';
export function Results() {
  return <section className="border-y border-edge bg-carbon" data-id="element-603" data-mp="wq51k7nip5y">
      <div className="mx-auto grid max-w-shell items-center gap-10 px-5 py-16 sm:px-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.25fr)] lg:gap-16 lg:px-10 lg:py-28" data-id="element-604" data-mp="3s3kiyingfo4g">
        <Reveal data-id="element-605" data-mp="34g2y772lxqaz">
          <span className="flex items-center gap-3" data-id="element-606" data-mp="2zfezdz850567">
            <span className="hairline h-px w-10" aria-hidden="true" data-id="element-607" data-mp="2zgzt5mmmnk30" />
            <span className="text-[11px] uppercase tracking-[0.28em] text-ember" data-id="element-608" data-mp="3dfzhet689wyn">Het verschil</span>
          </span>
          <h2 className="mt-5 font-display text-3xl font-extrabold leading-[1.05] tracking-tightest text-chalk sm:text-4xl" data-id="element-609" data-mp="39cjjzumc3skw">
            Sleep de knop. Dat is één polijstbeurt.
          </h2>
          <p className="mt-5 max-w-md text-[15px] leading-relaxed text-dim" data-id="element-610" data-mp="omc3u6k432df">
            Swirls en waskrassen zijn geen vuil — het is schade in de blanke lak. Een 2-staps correctie verwijdert
            80 tot 95% daarvan en brengt de glans definitief terug.
          </p>
          <Link to="/book" state={{
          serviceId: 'paint-correction'
        }} className="group mt-8 inline-flex items-center gap-2 rounded-full bg-ember px-6 py-3.5 text-sm font-semibold text-void transition-[background-color,box-shadow] duration-200 ease-smooth hover:bg-white hover:glow" data-id="element-611" data-mp="zn7qo5vjwf19">
            Lakcorrectie boeken
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-smooth group-hover:translate-x-0.5" aria-hidden="true" data-id="element-612" data-mp="bvshbt5cwxgi" />
          </Link>
        </Reveal>

        <Reveal delay={0.06} data-id="element-613" data-mp="3kdyd2de2a56x">
          <BeforeAfter before={img.before} after={img.after} beforeAlt="Doffe lak vol swirls vóór de correctie" afterAlt="Spiegelglans na een 2-staps polijstbehandeling" data-id="element-614" data-mp="3keq6pio3lsuk" />
        </Reveal>
      </div>
    </section>;
}